var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBagCart = function SvgBagCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#bag-cart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.083 0q1.56 0 2.655 1.095t1.095 2.655h1.827q.624 0 1.066.441.44.442.441 1.065V9.45a5 5 0 0 0-1.084-.118q-.083 0-.166.004v-4.08a.25.25 0 0 0-.081-.176.24.24 0 0 0-.176-.08H1.507a.25.25 0 0 0-.177.08.24.24 0 0 0-.08.176v9.487q0 .097.08.177t.177.08h6.622q.089.657.336 1.25H1.507q-.624 0-1.066-.441A1.45 1.45 0 0 1 0 14.743V5.256q0-.623.441-1.065.442-.441 1.066-.441h1.826q0-1.56 1.095-2.655T7.083 0m0 1.25a2.4 2.4 0 0 0-1.77.729 2.41 2.41 0 0 0-.73 1.771h5q0-1.041-.729-1.771a2.41 2.41 0 0 0-1.771-.729",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.583 5.833q0 1.041.73 1.77.729.73 1.77.73 1.042 0 1.771-.73a2.4 2.4 0 0 0 .729-1.77h1.25q0 1.56-1.095 2.655T7.083 9.583 4.428 8.488 3.333 5.833zM13.85 13.563h2.5v1.533h-2.5v2.5h-1.533v-2.5h-2.5v-1.533h2.5v-2.5h1.534z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bag-cart_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h17v18H0z"
  })))));
};
export default SvgBagCart;